import React from "react";
import ActionButton from "./../shared/button/ActionButton";
import MUIModal from "./../shared/MUIModal";

const WarrantyClaimDialog = ({
    localized,
    children,
    open,
    toggleDialog,
    count,
    fetching,
}) => {
    const buttonType = fetching ? "gray-outline" : "green-outline";
    const buttonText =
        count === 0
            ? localized.BtnAddNewClaim
            : localized.BtnReviewUnsubmittedItems.replace("{count}", `${count}`);

    return (
        <>
            <ActionButton
                text={buttonText}
                variant={buttonType}
                onClick={toggleDialog}
                disabled={fetching}
                tabIndex={fetching ? -1 : 0}
            />

            <MUIModal
                open={open}
                onClose={toggleDialog}
                title={localized.EnterItemDetails}
                fullWidth
                maxWidth="lg"
            >
                <div style={{ marginLeft: "1rem", overflowX: "hidden" }}>
                    {children}
                </div>
            </MUIModal>
        </>
    );
};

export default WarrantyClaimDialog;
